import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '0.9375rem',
    height: '0.9375rem',
  },
}));

const TextFormatIcon = (props) => {
  const classes = useStyles();
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 30 30"
      classes={{
        root: classes.root,
      }}
    >
      <path d="M20.9276 18.9083H10.0724L7.93422 24.2859H3L13.1974 0H17.8026L28 24.2859H23.0658L20.9276 18.9083ZM15.5 5.3082L11.8158 14.5716H19.1842L15.5 5.3082Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M28 30H3V27.3016H28V30Z" />
    </SvgIcon>
  );
};

export default TextFormatIcon;
